export const PreQualifierAssetTypeListItemStyles = {
  container: 'mx-4 my-8 w-48 h-32 cursor-pointer relative',
  selected: 'border-solid border-2 border-green rounded-lg',
  checkmark: 'absolute top-2 right-2 text-green',
  image: 'object-cover h-full w-full rounded-md shadow-md',
  text: 'mt-2 font-bold text-center'
}
